<template>
  <div class="quota-data tab-btn">
    <SimpleTable
      ref="QuotaDataTop"
      table-code="QuotaDataTop"
      :rightFrozenColCount="1"
      :columns="columns.top"
      :data="tableData.top"
      :loading="loading.top"
      @row-select="handleSelectTop"
    />

    <SimpleTable
      ref="QuotaDataBottom"
      table-code="QuotaDataBottom"
      :rightFrozenColCount="1"
      :columns="columns.bottom"
      :data="tableData.bottom"
      :loading="loading.bottom"
    />
  </div>
</template>

<script>
import { sortRecords, addCbFn, getOptions } from '@/utils/index'
import SimpleTable from '@/components/SimpleTable/index.vue'

export default {
  name: 'QuotaData',
  components: {
    SimpleTable
  },
  props: {
    billId: {
      type: String,
      default: () => {}
    }
  },
  data() {
    return {
      columns: {
        top: [
          { field: 'quotaLibraryName', title: '定额库名称' },
          { field: 'code', title: '编码' },
          { field: 'name', title: '子目名称' },
          { field: 'unit', title: '单位' },
          { field: 'quantity', title: '工程量' },
          { field: 'rate', title: '单价' },
          { field: 'amount', title: '合价' },
          { field: 'keywords', title: '子目关键词' },
          { field: 'resourceName', title: '汇总表人材机' }
        ],
        bottom: [
          { field: 'code', title: '编码', tree: true },
          { field: 'type', title: '类别' },
          { field: 'name', title: '人材机名称' },
          { field: 'spec', title: '规格型号' },
          { field: 'unit', title: '单位' },
          { field: 'quantity', title: '数量' },
          { field: 'rate', title: '单价' },
          { field: 'amount', title: '金额' },
          { field: 'quotaResourceKeywords', title: '预算关键词' },
          { field: 'resourceName', title: '汇总表人材机' }
        ]
      },
      tableData: {
        top: [],
        bottom: []
      },
      loading: {
        top: false,
        bottom: false
      }
    }
  },
  watch: {
    billId() {
      this.getTableDataTop()
    }
  },
  created() {
    this.getTableDataTop()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    async getTableDataTop() {
      this.tableData.top = []
      this.tableData.bottom = []
      if (!this.billId) return
      this.loading.top = true
      const res = await this.$service.get(
        'history-data-budget/bill/item/list',
        { billId: this.billId }
      )
      this.loading.top = false
      this.tableData.top = sortRecords(res?.data || [])
      this.$refs.QuotaDataTop.initialized(0, 1)
    },

    async getTableDataBototm(obj) {
      this.tableData.bottom = []
      this.loading.bottom = true
      const res = await this.$service.get(
        'history-data-budget/bill/item-resource/tree',
        { itemId: obj.id }
      )
      this.loading.bottom = false
      this.tableData.bottom = sortRecords(res?.data || [])
    },

    handleSelectTop(rows) {
      const obj = rows[0]?.[0]?.originData
      this.getTableDataBototm(obj)
    }
  }
}
</script>

<style scoped lang="less">
.quota-data {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 10px;
  height: 600px;
}
</style>
